
const initialState = {
    newData: null
  };
  
  const dataReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_DATA':
        return {
          ...state,
          newData: action.payload
        };
      default:
        return state;
    }
  };
  
  export default dataReducer;
  